

exports.Form = (handler, type, data = {}) ->
    self = this

    @getHandler = () ->
        return handler

    @setEditing = () ->
        @editing true

    @editing    = ko.observable false

    type = type.replace(' ', '')

    cls = App.loadClass "grower::viewmodels/machinery/" + type

    @layer = new cls this, data


    return this
